import { Container, i18n, Table, TableRow, http } from "@common";
import { useRef, useCallback, useState } from 'react';
import { routerPaths } from '../tool';
import { adminService } from "@api";

const columns = [
    { header: i18n.get('CIS_Admin_GroupManagement_GroupName_Entry'), sortable: true, valuePath: 'groupName' },
    { header: i18n.get('CIS_Admin_GroupManagement_GroupMembers_Entry'), sortable: true, valuePath: 'totalNumbers' },
    { header: i18n.get('CIS_Admin_GroupManagement_IhlName_Entry') },
];

const GroupManagement = () => {
    const tableRef = useRef();
    const [selectedItems, setSelectedItems] = useState([]);

    const filter = {
        onLoadData: adminService.groupsIhlFilter,
        items: [
            {
                id: 'filter-group-management-ihl',
                field: 'GroupsType',
                title: i18n.get('CIS_Admin_GroupManagement_IhlName_Entry'),
            }
        ],
        search: { id: 'search-group-management', placeholder: i18n.get('CIS_Admin_GroupManagement_Search_Message') },
    };

    const buttons = [
        {
            id: "btn-group-management-download",
            text: i18n.get('CIS_Admin_Common_Download_Entry'),
            classify: 'info',
            onClick: () => doDownload(),
            disabled: selectedItems?.length === 0
        },
    ];

    const doDownload = () => {
        $$.loading(true);
        const selectGroupId = [];
        if (selectedItems) {
            selectedItems.forEach(element => {
                selectGroupId.push(element.id);
            });
        }
        const params = {
            GroupId: selectGroupId,
            timeZone: new Date().getTimezoneOffset() / -60
        };
        adminService.groupManagementDownload(params).then(() => {
            return true;
        }).catch((e) => {
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.loading(false);
                $$.toast(e?.message, 'warning');
            }
        }).finally(() => {
            $$.loading(false);
        });
    };

    const onLoadData = useCallback((info) => {
        return adminService.groupManagementPaging(info);
    }, []);

    const onCheck = useCallback(selectedItems => {
        setSelectedItems(selectedItems);
    }, [setSelectedItems]);

    return (
        <Container>
            <Table
                id="table-group-management"
                ref={tableRef}
                onLoadData={onLoadData}
                rowTemplate={TableRowTemp}
                columns={columns}
                buttons={buttons}
                filter={filter}
                checkable
                onCheck={onCheck}
            />
        </Container>
    );
};


class TableRowTemp extends TableRow {
    render(Row, Cell) {
        const { ihl, groupName, totalMembers, id } = this.props.rowData;//groupDescription
        return (
            <Row>
                <Cell url={routerPaths.groupDetails.compile({ groupName: btoa(encodeURIComponent(groupName)), id })}>
                    {groupName || i18n.get('Common_NA_Entry')}
                </Cell>
                <Cell>{totalMembers || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{ihl || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default GroupManagement;